// document.addEventListener('DOMContentLoaded', function() {
//     const quantityThreshold = 11;

//     // Find the cart form
//     const cartForm = document.getElementById('cart');

//     if (cartForm) {
//         // Select all quantity input fields within the form
//         const quantityInputs = cartForm.querySelectorAll('input[type="number"]');

//         quantityInputs.forEach(input => {
//             // Add an event listener to each quantity input
//             input.addEventListener('change', function() {
//                 const quantityValue = parseInt(input.value, 10);

//                 // Find the closest product title element
//                 const productTitleElement = input.closest('tr').querySelector('.cart-item__name');

//                 if (productTitleElement) {
//                     const productTitle = productTitleElement.textContent.trim();
                    
//                     // // Debugging: Print statements to the console
//                     // console.log('Product Title:', productTitle);
//                     // console.log('Quantity Value:', quantityValue);

//                     // Check if the product title contains the phrase "Corporate Gift Box"
//                     if (productTitle.includes("Corporate Gift Box") && quantityValue >= quantityThreshold) {
//                         alert(`You have entered ${quantityValue} items for this product. Please contact sales@keppelandkismet.com for pricing.`);
//                     }
//                 }
//             });
//         });
//     }
// });

document.addEventListener('DOMContentLoaded', function() {
    const quantityThreshold = 11;
    let alertTriggered = false; // To prevent duplicate alerts

    function attachEventListeners() {
        // Find the cart form
        const cartForm = document.getElementById('cart');

        if (cartForm) {
            // Select all quantity input fields within the form
            const quantityInputs = cartForm.querySelectorAll('input[type="number"]');

            quantityInputs.forEach(input => {
                // Store the previous value of the input
                let previousValue = input.value;

                // Remove any existing event listener to avoid duplication
                input.removeEventListener('change', handleQuantityChange);
                // Add the event listener
                input.addEventListener('change', function(event) {
                    handleQuantityChange(event, previousValue);
                });

                // Update previousValue every time the input value is set
                input.addEventListener('focus', function() {
                    previousValue = input.value;
                });
            });
        }
    }

    function handleQuantityChange(event, previousValue) {
        const input = event.target;
        const quantityValue = parseInt(input.value, 10);

        // Find the closest product title element
        const productTitleElement = input.closest('tr').querySelector('.cart-item__name');

        if (productTitleElement) {
            const productTitle = productTitleElement.textContent.trim();

            // Check if the product title contains the phrase "Corporate Gift Box" and the quantity is over the threshold
            if (productTitle.includes("Corporate Gift Box") && quantityValue >= quantityThreshold) {
                if (!alertTriggered) {
                    // Display an alert message
                    alert(`You have entered ${quantityValue} items for this product. Please contact sales@keppelandkismet.com for pricing.`);
                    alertTriggered = true;

                    // Reset the quantity back to the previous value
                    input.value = previousValue;

                    // Trigger input event to update any UI elements dependent on this value
                    input.dispatchEvent(new Event('input'));

                    // Reset the trigger after a short delay to allow further changes
                    setTimeout(() => {
                        alertTriggered = false;
                    }, 500);
                }
            }
        }
    }

    // Attach event listeners initially
    attachEventListeners();

    // Use MutationObserver to reattach listeners after the cart updates
    const observer = new MutationObserver(attachEventListeners);

    // Observe changes in the cart's contents
    observer.observe(document.getElementById('cart'), {
        childList: true, // Listen for direct children being added/removed
        subtree: true,   // Also listen for changes in the subtree
    });
});
